/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetBudgetDto } from './GetBudgetDto';
import {
    GetBudgetDtoFromJSON,
    GetBudgetDtoFromJSONTyped,
    GetBudgetDtoToJSON,
} from './GetBudgetDto';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';
import type { GetEmailAddressDto } from './GetEmailAddressDto';
import {
    GetEmailAddressDtoFromJSON,
    GetEmailAddressDtoFromJSONTyped,
    GetEmailAddressDtoToJSON,
} from './GetEmailAddressDto';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';
import type { GetInvoiceEstimateItemDto } from './GetInvoiceEstimateItemDto';
import {
    GetInvoiceEstimateItemDtoFromJSON,
    GetInvoiceEstimateItemDtoFromJSONTyped,
    GetInvoiceEstimateItemDtoToJSON,
} from './GetInvoiceEstimateItemDto';
import type { GetPurchaserDto } from './GetPurchaserDto';
import {
    GetPurchaserDtoFromJSON,
    GetPurchaserDtoFromJSONTyped,
    GetPurchaserDtoToJSON,
} from './GetPurchaserDto';
import type { GetSalesInvoiceDto } from './GetSalesInvoiceDto';
import {
    GetSalesInvoiceDtoFromJSON,
    GetSalesInvoiceDtoFromJSONTyped,
    GetSalesInvoiceDtoToJSON,
} from './GetSalesInvoiceDto';
import type { GetSalesInvoiceDtoRecipientClient } from './GetSalesInvoiceDtoRecipientClient';
import {
    GetSalesInvoiceDtoRecipientClientFromJSON,
    GetSalesInvoiceDtoRecipientClientFromJSONTyped,
    GetSalesInvoiceDtoRecipientClientToJSON,
} from './GetSalesInvoiceDtoRecipientClient';
import type { GetSalesInvoicePositionDto } from './GetSalesInvoicePositionDto';
import {
    GetSalesInvoicePositionDtoFromJSON,
    GetSalesInvoicePositionDtoFromJSONTyped,
    GetSalesInvoicePositionDtoToJSON,
} from './GetSalesInvoicePositionDto';
import type { GetSalesInvoiceProjectDto } from './GetSalesInvoiceProjectDto';
import {
    GetSalesInvoiceProjectDtoFromJSON,
    GetSalesInvoiceProjectDtoFromJSONTyped,
    GetSalesInvoiceProjectDtoToJSON,
} from './GetSalesInvoiceProjectDto';

/**
 * 
 * @export
 * @interface GetSalesInvoiceWithAmountDto
 */
export interface GetSalesInvoiceWithAmountDto {
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    number: string;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    invoiceDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    saleDate: Date;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    type: GetSalesInvoiceWithAmountDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    currency: GetSalesInvoiceWithAmountDtoCurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    status: GetSalesInvoiceWithAmountDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    paymentForm: GetSalesInvoiceWithAmountDtoPaymentFormEnum;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    payableDays: GetDictionaryDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    printProjectNumber: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    isPaymentFromReceiptDate: boolean;
    /**
     * 
     * @type {Array<GetInvoiceEstimateItemDto>}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    invoiceEstimateItems?: Array<GetInvoiceEstimateItemDto>;
    /**
     * 
     * @type {Array<GetSalesInvoicePositionDto>}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    salesInvoicePositions?: Array<GetSalesInvoicePositionDto>;
    /**
     * 
     * @type {Array<GetSalesInvoiceProjectDto>}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    salesInvoiceProjects?: Array<GetSalesInvoiceProjectDto>;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    isOnePositionOnInvoice: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    onePositionName: string;
    /**
     * 
     * @type {number}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    exchangeRate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    exchangeRateDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    gtuCodeId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    documentCodeIds: Array<string>;
    /**
     * 
     * @type {GetSalesInvoiceDto}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    parent: GetSalesInvoiceDto;
    /**
     * 
     * @type {GetSalesInvoiceDto}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    originalInvoice: GetSalesInvoiceDto;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    company: GetCompanyDto;
    /**
     * 
     * @type {GetPurchaserDto}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    purchaser: GetPurchaserDto;
    /**
     * 
     * @type {GetSalesInvoiceDtoRecipientClient}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    recipientClient?: GetSalesInvoiceDtoRecipientClient | null;
    /**
     * 
     * @type {GetBudgetDto}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    budget: GetBudgetDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    isSymphonyCode?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    isSymphonyCodeForRecipient?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    textOverItems: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    correctionReasonTxt?: string | null;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    correctionReasonDict?: GetDictionaryDto;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    approver?: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    approvedTs?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    sentToSymphonyHandel?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    sentToSymphonyHandelTs?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    emailText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    emailSubject?: string | null;
    /**
     * 
     * @type {GetEmailAddressDto}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    emailAddress?: GetEmailAddressDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    sendEmail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    hasAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    toKsef: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    statusKsef?: GetSalesInvoiceWithAmountDtoStatusKsefEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    numberKsef?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    qrCodeKsef?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    qrCodeKsefVerification?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    totalPaid?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    lastPaymentDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    paymentStatus?: GetSalesInvoiceWithAmountDtoPaymentStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    ksefDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    ksefRejectionReason?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    amountNet?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    amountGross?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    amountNetDelta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    amountGrossDelta?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    purchaserClientName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    purchaserClientAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    purchaserClientNip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    recipientClientName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    recipientClientAddress?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    recipientClientNip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    amount: string;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    owner: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceWithAmountDto
     */
    ts: Date;
}


/**
 * @export
 */
export const GetSalesInvoiceWithAmountDtoTypeEnum = {
    Foreign: 'Foreign',
    Domestic: 'Domestic'
} as const;
export type GetSalesInvoiceWithAmountDtoTypeEnum = typeof GetSalesInvoiceWithAmountDtoTypeEnum[keyof typeof GetSalesInvoiceWithAmountDtoTypeEnum];

/**
 * @export
 */
export const GetSalesInvoiceWithAmountDtoCurrencyEnum = {
    Pln: 'PLN',
    Usd: 'USD',
    Eur: 'EUR',
    Czk: 'CZK',
    Rub: 'RUB',
    Huf: 'HUF',
    Gbp: 'GBP',
    Bgn: 'BGN',
    Ron: 'RON',
    Hrk: 'HRK',
    Aud: 'AUD'
} as const;
export type GetSalesInvoiceWithAmountDtoCurrencyEnum = typeof GetSalesInvoiceWithAmountDtoCurrencyEnum[keyof typeof GetSalesInvoiceWithAmountDtoCurrencyEnum];

/**
 * @export
 */
export const GetSalesInvoiceWithAmountDtoStatusEnum = {
    Draft: 'Draft',
    Generated: 'Generated',
    Sent: 'Sent',
    InKseF: 'InKSeF',
    Paid: 'Paid'
} as const;
export type GetSalesInvoiceWithAmountDtoStatusEnum = typeof GetSalesInvoiceWithAmountDtoStatusEnum[keyof typeof GetSalesInvoiceWithAmountDtoStatusEnum];

/**
 * @export
 */
export const GetSalesInvoiceWithAmountDtoPaymentFormEnum = {
    BankTransfer: 'BankTransfer',
    Compensation: 'Compensation',
    Prepayment: 'Prepayment',
    Paid: 'Paid'
} as const;
export type GetSalesInvoiceWithAmountDtoPaymentFormEnum = typeof GetSalesInvoiceWithAmountDtoPaymentFormEnum[keyof typeof GetSalesInvoiceWithAmountDtoPaymentFormEnum];

/**
 * @export
 */
export const GetSalesInvoiceWithAmountDtoStatusKsefEnum = {
    AcceptedInKseF: 'AcceptedInKSeF',
    RejectedInKseF: 'RejectedInKSeF',
    WaitingForKseF: 'WaitingForKSeF',
    Offline: 'OFFLINE'
} as const;
export type GetSalesInvoiceWithAmountDtoStatusKsefEnum = typeof GetSalesInvoiceWithAmountDtoStatusKsefEnum[keyof typeof GetSalesInvoiceWithAmountDtoStatusKsefEnum];

/**
 * @export
 */
export const GetSalesInvoiceWithAmountDtoPaymentStatusEnum = {
    Paid: 'Paid',
    PartiallyPaid: 'PartiallyPaid',
    Pending: 'Pending',
    Overdue: 'Overdue',
    OverduePartiallyPaid: 'OverduePartiallyPaid'
} as const;
export type GetSalesInvoiceWithAmountDtoPaymentStatusEnum = typeof GetSalesInvoiceWithAmountDtoPaymentStatusEnum[keyof typeof GetSalesInvoiceWithAmountDtoPaymentStatusEnum];


/**
 * Check if a given object implements the GetSalesInvoiceWithAmountDto interface.
 */
export function instanceOfGetSalesInvoiceWithAmountDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "number" in value;
    isInstance = isInstance && "invoiceDate" in value;
    isInstance = isInstance && "saleDate" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "paymentForm" in value;
    isInstance = isInstance && "payableDays" in value;
    isInstance = isInstance && "printProjectNumber" in value;
    isInstance = isInstance && "isPaymentFromReceiptDate" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "isOnePositionOnInvoice" in value;
    isInstance = isInstance && "onePositionName" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "gtuCodeId" in value;
    isInstance = isInstance && "documentCodeIds" in value;
    isInstance = isInstance && "parent" in value;
    isInstance = isInstance && "originalInvoice" in value;
    isInstance = isInstance && "company" in value;
    isInstance = isInstance && "purchaser" in value;
    isInstance = isInstance && "budget" in value;
    isInstance = isInstance && "textOverItems" in value;
    isInstance = isInstance && "toKsef" in value;
    isInstance = isInstance && "amount" in value;
    isInstance = isInstance && "owner" in value;
    isInstance = isInstance && "ts" in value;

    return isInstance;
}

export function GetSalesInvoiceWithAmountDtoFromJSON(json: any): GetSalesInvoiceWithAmountDto {
    return GetSalesInvoiceWithAmountDtoFromJSONTyped(json, false);
}

export function GetSalesInvoiceWithAmountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSalesInvoiceWithAmountDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'],
        'invoiceDate': (new Date(json['invoiceDate'])),
        'saleDate': (new Date(json['saleDate'])),
        'type': json['type'],
        'currency': json['currency'],
        'status': json['status'],
        'paymentForm': json['paymentForm'],
        'payableDays': GetDictionaryDtoFromJSON(json['payableDays']),
        'printProjectNumber': json['printProjectNumber'],
        'isPaymentFromReceiptDate': json['isPaymentFromReceiptDate'],
        'invoiceEstimateItems': !exists(json, 'invoiceEstimateItems') ? undefined : ((json['invoiceEstimateItems'] as Array<any>).map(GetInvoiceEstimateItemDtoFromJSON)),
        'salesInvoicePositions': !exists(json, 'salesInvoicePositions') ? undefined : ((json['salesInvoicePositions'] as Array<any>).map(GetSalesInvoicePositionDtoFromJSON)),
        'salesInvoiceProjects': !exists(json, 'salesInvoiceProjects') ? undefined : ((json['salesInvoiceProjects'] as Array<any>).map(GetSalesInvoiceProjectDtoFromJSON)),
        'active': json['active'],
        'isOnePositionOnInvoice': json['isOnePositionOnInvoice'],
        'onePositionName': json['onePositionName'],
        'systemNumber': json['systemNumber'],
        'exchangeRate': !exists(json, 'exchangeRate') ? undefined : json['exchangeRate'],
        'exchangeRateDescription': !exists(json, 'exchangeRateDescription') ? undefined : json['exchangeRateDescription'],
        'gtuCodeId': json['gtuCodeId'],
        'documentCodeIds': json['documentCodeIds'],
        'parent': GetSalesInvoiceDtoFromJSON(json['parent']),
        'originalInvoice': GetSalesInvoiceDtoFromJSON(json['originalInvoice']),
        'company': GetCompanyDtoFromJSON(json['company']),
        'purchaser': GetPurchaserDtoFromJSON(json['purchaser']),
        'recipientClient': !exists(json, 'recipientClient') ? undefined : GetSalesInvoiceDtoRecipientClientFromJSON(json['recipientClient']),
        'budget': GetBudgetDtoFromJSON(json['budget']),
        'isSymphonyCode': !exists(json, 'isSymphonyCode') ? undefined : json['isSymphonyCode'],
        'isSymphonyCodeForRecipient': !exists(json, 'isSymphonyCodeForRecipient') ? undefined : json['isSymphonyCodeForRecipient'],
        'textOverItems': json['textOverItems'],
        'correctionReasonTxt': !exists(json, 'correctionReasonTxt') ? undefined : json['correctionReasonTxt'],
        'correctionReasonDict': !exists(json, 'correctionReasonDict') ? undefined : GetDictionaryDtoFromJSON(json['correctionReasonDict']),
        'approver': !exists(json, 'approver') ? undefined : GetEmployeeDtoFromJSON(json['approver']),
        'approvedTs': !exists(json, 'approvedTs') ? undefined : (json['approvedTs'] === null ? null : new Date(json['approvedTs'])),
        'sentToSymphonyHandel': !exists(json, 'sentToSymphonyHandel') ? undefined : json['sentToSymphonyHandel'],
        'sentToSymphonyHandelTs': !exists(json, 'sentToSymphonyHandelTs') ? undefined : (json['sentToSymphonyHandelTs'] === null ? null : new Date(json['sentToSymphonyHandelTs'])),
        'emailText': !exists(json, 'emailText') ? undefined : json['emailText'],
        'emailSubject': !exists(json, 'emailSubject') ? undefined : json['emailSubject'],
        'emailAddress': !exists(json, 'emailAddress') ? undefined : GetEmailAddressDtoFromJSON(json['emailAddress']),
        'sendEmail': !exists(json, 'sendEmail') ? undefined : json['sendEmail'],
        'hasAttachments': !exists(json, 'hasAttachments') ? undefined : json['hasAttachments'],
        'toKsef': json['toKsef'],
        'statusKsef': !exists(json, 'statusKsef') ? undefined : json['statusKsef'],
        'numberKsef': !exists(json, 'numberKsef') ? undefined : json['numberKsef'],
        'qrCodeKsef': !exists(json, 'qrCodeKsef') ? undefined : json['qrCodeKsef'],
        'qrCodeKsefVerification': !exists(json, 'qrCodeKsefVerification') ? undefined : json['qrCodeKsefVerification'],
        'totalPaid': !exists(json, 'totalPaid') ? undefined : json['totalPaid'],
        'lastPaymentDate': !exists(json, 'lastPaymentDate') ? undefined : (json['lastPaymentDate'] === null ? null : new Date(json['lastPaymentDate'])),
        'paymentStatus': !exists(json, 'paymentStatus') ? undefined : json['paymentStatus'],
        'ksefDate': !exists(json, 'ksefDate') ? undefined : (json['ksefDate'] === null ? null : new Date(json['ksefDate'])),
        'ksefRejectionReason': !exists(json, 'ksefRejectionReason') ? undefined : json['ksefRejectionReason'],
        'amountNet': !exists(json, 'amountNet') ? undefined : json['amountNet'],
        'amountGross': !exists(json, 'amountGross') ? undefined : json['amountGross'],
        'amountNetDelta': !exists(json, 'amountNetDelta') ? undefined : json['amountNetDelta'],
        'amountGrossDelta': !exists(json, 'amountGrossDelta') ? undefined : json['amountGrossDelta'],
        'purchaserClientName': !exists(json, 'purchaserClientName') ? undefined : json['purchaserClientName'],
        'purchaserClientAddress': !exists(json, 'purchaserClientAddress') ? undefined : json['purchaserClientAddress'],
        'purchaserClientNip': !exists(json, 'purchaserClientNip') ? undefined : json['purchaserClientNip'],
        'recipientClientName': !exists(json, 'recipientClientName') ? undefined : json['recipientClientName'],
        'recipientClientAddress': !exists(json, 'recipientClientAddress') ? undefined : json['recipientClientAddress'],
        'recipientClientNip': !exists(json, 'recipientClientNip') ? undefined : json['recipientClientNip'],
        'amount': json['amount'],
        'owner': GetEmployeeDtoFromJSON(json['owner']),
        'ts': (new Date(json['ts'])),
    };
}

export function GetSalesInvoiceWithAmountDtoToJSON(value?: GetSalesInvoiceWithAmountDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'number': value.number,
        'invoiceDate': (value.invoiceDate.toISOString()),
        'saleDate': (value.saleDate.toISOString()),
        'type': value.type,
        'currency': value.currency,
        'status': value.status,
        'paymentForm': value.paymentForm,
        'payableDays': GetDictionaryDtoToJSON(value.payableDays),
        'printProjectNumber': value.printProjectNumber,
        'isPaymentFromReceiptDate': value.isPaymentFromReceiptDate,
        'invoiceEstimateItems': value.invoiceEstimateItems === undefined ? undefined : ((value.invoiceEstimateItems as Array<any>).map(GetInvoiceEstimateItemDtoToJSON)),
        'salesInvoicePositions': value.salesInvoicePositions === undefined ? undefined : ((value.salesInvoicePositions as Array<any>).map(GetSalesInvoicePositionDtoToJSON)),
        'salesInvoiceProjects': value.salesInvoiceProjects === undefined ? undefined : ((value.salesInvoiceProjects as Array<any>).map(GetSalesInvoiceProjectDtoToJSON)),
        'active': value.active,
        'isOnePositionOnInvoice': value.isOnePositionOnInvoice,
        'onePositionName': value.onePositionName,
        'systemNumber': value.systemNumber,
        'exchangeRate': value.exchangeRate,
        'exchangeRateDescription': value.exchangeRateDescription,
        'gtuCodeId': value.gtuCodeId,
        'documentCodeIds': value.documentCodeIds,
        'parent': GetSalesInvoiceDtoToJSON(value.parent),
        'originalInvoice': GetSalesInvoiceDtoToJSON(value.originalInvoice),
        'company': GetCompanyDtoToJSON(value.company),
        'purchaser': GetPurchaserDtoToJSON(value.purchaser),
        'recipientClient': GetSalesInvoiceDtoRecipientClientToJSON(value.recipientClient),
        'budget': GetBudgetDtoToJSON(value.budget),
        'isSymphonyCode': value.isSymphonyCode,
        'isSymphonyCodeForRecipient': value.isSymphonyCodeForRecipient,
        'textOverItems': value.textOverItems,
        'correctionReasonTxt': value.correctionReasonTxt,
        'correctionReasonDict': GetDictionaryDtoToJSON(value.correctionReasonDict),
        'approver': GetEmployeeDtoToJSON(value.approver),
        'approvedTs': value.approvedTs === undefined ? undefined : (value.approvedTs === null ? null : value.approvedTs.toISOString()),
        'sentToSymphonyHandel': value.sentToSymphonyHandel,
        'sentToSymphonyHandelTs': value.sentToSymphonyHandelTs === undefined ? undefined : (value.sentToSymphonyHandelTs === null ? null : value.sentToSymphonyHandelTs.toISOString()),
        'emailText': value.emailText,
        'emailSubject': value.emailSubject,
        'emailAddress': GetEmailAddressDtoToJSON(value.emailAddress),
        'sendEmail': value.sendEmail,
        'hasAttachments': value.hasAttachments,
        'toKsef': value.toKsef,
        'statusKsef': value.statusKsef,
        'numberKsef': value.numberKsef,
        'qrCodeKsef': value.qrCodeKsef,
        'qrCodeKsefVerification': value.qrCodeKsefVerification,
        'totalPaid': value.totalPaid,
        'lastPaymentDate': value.lastPaymentDate === undefined ? undefined : (value.lastPaymentDate === null ? null : value.lastPaymentDate.toISOString()),
        'paymentStatus': value.paymentStatus,
        'ksefDate': value.ksefDate === undefined ? undefined : (value.ksefDate === null ? null : value.ksefDate.toISOString()),
        'ksefRejectionReason': value.ksefRejectionReason,
        'amountNet': value.amountNet,
        'amountGross': value.amountGross,
        'amountNetDelta': value.amountNetDelta,
        'amountGrossDelta': value.amountGrossDelta,
        'purchaserClientName': value.purchaserClientName,
        'purchaserClientAddress': value.purchaserClientAddress,
        'purchaserClientNip': value.purchaserClientNip,
        'recipientClientName': value.recipientClientName,
        'recipientClientAddress': value.recipientClientAddress,
        'recipientClientNip': value.recipientClientNip,
        'amount': value.amount,
        'owner': GetEmployeeDtoToJSON(value.owner),
        'ts': (value.ts.toISOString()),
    };
}

